import React from "react";
import ExplanationPanel from "./ExplanationPanel";
import styles from "./ExplanationPanelCorrect.module.css";

import ExplanationRightImage from "../../images/explanation-right.png";

function ExplanationPanelCorrect({ children, isShown }) {
  return (
    <ExplanationPanel isShown={isShown} image={ExplanationRightImage}>
      {children}
    </ExplanationPanel>
  );
}

export default ExplanationPanelCorrect;
